import { NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import { getSchoolData } from "@/lib/api-clients/candidate-api-client";

export default function useSchoolData({ ncesId }: { ncesId: string }) {
  return useQuery({
    queryKey: [`school-data-${ncesId}`],
    queryFn: async () => {
      return await getSchoolData(
        NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY,
      )(ncesId);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes as school data is not expected to change frequently
  });
}
